<template>
  <div class="login">
    <el-form
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <h3></h3>
      <p>手机号:</p>
      <el-form-item label="" prop="id">
        <el-input v-model.number="ruleForm.id" maxlength="11"></el-input>
      </el-form-item>
      <p>密码:</p>
      <el-form-item label="" prop="pass">
        <el-input
          type="password"
          v-model="ruleForm.pass"
          autocomplete="off"
          maxlength="16"
          @keydown="passkeydown()"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >立即登录</el-button
        >
      </el-form-item>
      <div class="foot">
        <div class="fleft">
          <p>还没有账号?</p>
          <router-link to="/register">立即注册</router-link>
        </div>
        <router-link to="/changepass">忘记密码</router-link>
      </div>
    </el-form>
  </div>
</template>

<script>
import { checkAge, validatePass } from '@/utils/validate.js'
export default {
  data() {
    return {
      ruleForm: {
        pass: '',
        id: ''
      },
      rules: {
        pass: [{ validator: validatePass, trigger: 'blur' }],
        id: [{ validator: checkAge, trigger: 'blur' }]
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  box-sizing: border-box;
  height: 100%;
  min-height: 440px;
  background-color: #2c374a;
  padding-top: 75px;
  .el-form {
    position: absolute;
    top: 16%;
    left: 50%;
    transform: translateX(-50%);
    padding: 24px 48px;
    width: 500px;
    height: 366px;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 10px;
    h3 {
      text-align: center;
      font-size: 20px;
      margin-bottom: 40px;
      color: #333;
    }
    p {
      font-size: 14px;
      color: rgb(40, 65, 65);
      text-indent: 1em;
    }
    /deep/.el-form-item {
      width: 400px;
      height: 40px;
      .el-form-item__content {
        margin-left: 0 !important;
      }
    }
    .el-button {
      width: 400px;
    }
    .foot {
      display: flex;
      justify-content: space-between;
      .fleft {
        display: flex;
      }
      a {
        color: #276ff4;
      }
    }
  }
}
</style>
